import { Component } from 'react'
import { GridTable } from '../../Sidebar/SidebarStyles';
import { Alert, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, IconButton, Paper, Snackbar, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import { Refresh, Edit, Cancel, Check as CheckIcon } from '@mui/icons-material';
import { AddorUpdateUserAccess, UpdateUserAccessStatus, getAllUserAccess } from '../../ApiSevices/UserMasterApis';
import Search from '@mui/icons-material/Search';
import { green, red } from '@mui/material/colors';
import ConfirmationDialogComponent from "../../Common/ConfirmationDialogComponent";
import { MenuItem } from '@mui/material';

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    loading: boolean;
    tableData: any[] | undefined;
    copyList: any[] | undefined;
    email: string;
    skills: {
        AdminAccess: boolean;
    };

    qcConfig: {
        table1: boolean; // Backup Records
        table2: boolean; // Deletion Report
    };
    qcDeletionConfig: {
        table13: boolean;
    };
    confirmationDialog: {
        isOpen: boolean,
        recordId: any,
        message: string,
        activate: boolean
    }
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
    isQcGlobalAdmin: boolean;
    errors: {
        email: string;
    };
    isOpenEditDialog: boolean;
    selectedRowForEdit?: any;
    searchText: string;
}

// const roleMapping = {
//     QcReport: "Admin Access",
// };

export default class QcUserAccess extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            tableData: [],
            copyList: [],
            email: "",
            skills: {
                AdminAccess: false,
            },

            qcConfig: {
                table1: false,
                table2: false,
            },
            qcDeletionConfig: {
                table13: false,
            },
            errors: {
                email: ""
            },
            confirmationDialog: {
                isOpen: false,
                recordId: 0,
                message: "",
                activate: false
            },
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'info',
            isQcGlobalAdmin: false,
            isOpenEditDialog: false,
            selectedRowForEdit: null,
            searchText: "",
        };
    }

    isValidEmail(email: string) {
        const regex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email.trim());
    };

    async componentDidMount() {
        this.UpdateUserAccessList();
    }
    handleCheckboxChangeQcDeletion = (e: any) => {
        const { name, checked } = e.target;

        this.setState({
            qcDeletionConfig: {
                ...this.state.qcDeletionConfig,
                [name]: checked,
            },
        });
    };

    MapUserAccessData = (data: any[]) => {
        try {
            return (
                data?.map((item: any) => {
                    const access: string[] = [];

                    const roles =
                        item.Role
                            ?.replace("[", "")
                            .replace("]", "")
                            .split(",")
                            .map((x: string) => x.trim()) || [];

                    roles.forEach((role: string) => {
                        switch (role) {
                            case "report":
                                access.push("Admin Access");
                                break;
                        }
                    });

                    if (item.QcDeletionConfig) {
                        access.push("Operational Console");
                    }

                    if (item.IsQcGlobalAdmin) {
                        access.push("Global Admin");
                    }

                    return {
                        ...item,
                        value: access.join(","),
                        key: item.Id,
                    };
                }) || []
            );
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    UpdateUserAccessList = async () => {
        this.setState({ loading: true });
        try {
            const response = await getAllUserAccess();
            const data = this.MapUserAccessData(response) || [];

            this.setState({
                tableData: data,
                copyList: data
            });
        } catch (error) {
            console.error(error);
        } finally {
            this.setState({
                loading: false
            });
        }
    };

    handleEmailChange = (e: any) => {
        const email = e.target.value;

        this.setState({
            email,
            errors: {
                ...this.state.errors,
                email:
                    email === ""
                        ? "Email is required"
                        : !this.isValidEmail(email)
                            ? "Enter a valid email"
                            : "",
            },
        });
    };

    handleCheckboxChange = (e: any) => {
        const { name, checked } = e.target;

        const updatedSkills = {
            ...this.state.skills,
            [name]: checked,
        };

        const isSelected = Object.values(updatedSkills).some(Boolean);

        this.setState({
            skills: updatedSkills
        });
    };

    handleCheckboxChangeQc = (e: any) => {
        const { name, checked } = e.target;

        const updatedSkills = {
            ...this.state.qcConfig,
            [name]: checked,
        };

        this.setState({
            qcConfig: updatedSkills
        });
    };

    convertToKeyValueArray(obj: Record<string, any>) {
        return Object.entries(obj).map(([key, value]) => ({
            key,
            value
        }));
    };

    handleSubmit = async (e: any) => {
        this.setState({ loading: true });
        try {

            e.preventDefault();
            const { email } = this.state;
            const validEmail = this.isValidEmail(email);
            if (!validEmail) {
                this.setState({
                    errors: {
                        email: validEmail ? "" : "Enter a valid email"
                    }
                });
                return;
            }

            const self = this;
            const role = this.state.skills.AdminAccess
                ? "[report]"
                : "";

            const { qcConfig } = this.state;

            const selectedQcConfig = (
                Object.keys(qcConfig) as (keyof IState["qcConfig"])[]
            )
                .filter(key => qcConfig[key])
                .join(",");

            const { qcDeletionConfig } = this.state;

            const selectedQcDeletionConfig =
                Object.keys(qcDeletionConfig)
                    .filter(key => qcDeletionConfig[key as keyof typeof qcDeletionConfig])
                    .join(",");

            const body = {
                Id: this.state.selectedRowForEdit?.Id || 0,
                UserName: this.state.email,
                Role: role,
                Roles: this.state.selectedRowForEdit?.Roles,
                AdminConfig: this.state.selectedRowForEdit?.AdminConfig,
                QcConfig: selectedQcConfig,
                QcDeletionConfig: selectedQcDeletionConfig,
                IsGlobalAdmin:this.state.selectedRowForEdit.IsGlobalAdmin,
                IsQcGlobalAdmin: this.state.isQcGlobalAdmin,
                IsActive: true,
                IsDeleted: false,
                CreatedOn: this.state.selectedRowForEdit?.CreatedOn ?? new Date().toISOString(),
                UpdatedOn: new Date().toISOString()
            };
            const response = await AddorUpdateUserAccess(body)
            if (response?.status === 200) {
                this.UpdateUserAccessList();
            }
            this.resetDialogState();
        } catch (error: any) {
            console.error("Error Submitting User:" + error);
            if (error?.status != 200) {
                alert(error?.response?.data?.detail);
            }
            this.resetDialogState();
        } finally {
            this.UpdateUserAccessList();
            this.setState({ loading: false });
        }
    };

    onSearch(e: any) {
        const searchText = e.target.value;
        const result = this.state.copyList?.filter((e: any) => e.UserName.toLowerCase().includes(searchText.toLowerCase()));
        this.setState({ tableData: result });
    }

    MapForEditingRow(row: any) {
        const selectedValues = row.value.split(',');
        this.setState({
            isOpenEditDialog: true,
            email: row.UserName,
            skills: {
                AdminAccess: selectedValues.includes("Admin Access"),
            },
            qcConfig: {
                table1: row.QcConfig?.includes("table1"),
                table2: row.QcConfig?.includes("table2"),
            },
            qcDeletionConfig: {
                table13: row.QcDeletionConfig?.includes("table13"),
            },
            isQcGlobalAdmin: row.IsQcGlobalAdmin,
            selectedRowForEdit: row
        });
    }

    getChipColor(value: any, isGlobalAdminOnly = false) {
        if (isGlobalAdminOnly) {
            return {
                backgroundColor: "#FEF3C7",
                color: "#D97706",
            };
        }

        switch (value?.trim()) {
            case "Admin Access":
                return {
                    backgroundColor: "#E8F0FE",
                    color: "#1A73E8",
                };

            case "Global Admin":
                return {
                    backgroundColor: "#FEF3C7",
                    color: "#D97706",
                }
            default:
                return {
                    backgroundColor: "#F1F3F4",
                    color: "#5F6368",
                };
        }
    };

    resetDialogState() {
        this.setState({
            isOpenEditDialog: false,
            email: "",
            skills: {
                AdminAccess: false,
            },

            qcConfig: {
                table1: false,
                table2: false
            },
            qcDeletionConfig: {
                table13: false,
            },
            errors: { email: "" },
            // adminConfig: { table2: false, table7: false, table10: false },
            // deletionConfig: { table2: false, table4: false, table5: false },
            selectedRowForEdit: null,
            isQcGlobalAdmin: false
        })
    }

    async onConfirmationDialog() {
        try {
            this.setState({ loading: true });
            const { confirmationDialog } = this.state;
            const res = await UpdateUserAccessStatus(confirmationDialog.recordId.Id, !confirmationDialog.recordId.IsActive)
            if (res?.status === 200) {
                this.showSnackbar("Updated Successfully", "success");
                this.setState({
                    confirmationDialog: {
                        isOpen: false,
                        message: "",
                        recordId: null,
                        activate: false
                    }
                });
                this.UpdateUserAccessList();
            }
        } catch (error) {
            this.showSnackbar("Error updating Access", "error");
        } finally {
            this.setState({ loading: false });
        }
    }

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    render() {
        const { loading, tableData, errors, email, skills, qcConfig, qcDeletionConfig, isQcGlobalAdmin, confirmationDialog, snackbarOpen, snackbarMessage, snackbarSeverity } = this.state;
        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}

                <Dialog
                    open={this.state.isOpenEditDialog}
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle sx={{ fontWeight: 'bold', fontSize: '20px', paddingBottom: 0 }}>
                        {this.state.selectedRowForEdit ? "Edit" : "Add"} Users
                    </DialogTitle>
                    <Box component="form" onSubmit={this.handleSubmit}>
                        <DialogContent sx={{ paddingTop: '8px', flexDirection: 'column', display: 'flex', gap: '10px' }}>
                            <Grid
                                container
                                spacing={3}
                                alignItems="flex-start"
                                sx={{ mb: 2 }}
                            >
                                <Grid item xs={8}>
                                    <FormControl fullWidth error={Boolean(errors.email)}>
                                        <FormLabel>Email</FormLabel>

                                        {this.state.selectedRowForEdit ? (
                                            <Typography sx={{ mt: 1 }}>{email}</Typography>
                                        ) : (
                                            <TextField
                                                fullWidth
                                                value={email}
                                                onChange={this.handleEmailChange}
                                                error={Boolean(errors.email)}
                                                helperText={errors.email}
                                                size="small"
                                            />
                                        )}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={4}>
                                    <FormControl>
                                        <FormLabel sx={{ mb: 1 }}>
                                            Global Admin
                                        </FormLabel>

                                        <Switch
                                            checked={this.state.isQcGlobalAdmin}
                                            onChange={(e, checked) => {
                                                this.setState({
                                                    isQcGlobalAdmin: checked
                                                });
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Grid container spacing={4} sx={{ mt: 0, pt: 0 }}>

                                {/* Left Side */}
                                <Grid item xs={12} md={4}>
                                    <FormControl margin="normal">
                                        <FormLabel>Access</FormLabel>

                                        <FormGroup>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={skills.AdminAccess}
                                                        onChange={this.handleCheckboxChange}
                                                        name="AdminAccess"
                                                    />
                                                }
                                                label="Admin Control Centre"
                                            />

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={qcDeletionConfig.table13}
                                                        onChange={this.handleCheckboxChangeQcDeletion}
                                                        name="table13"
                                                    />
                                                }
                                                label="Operations Console"
                                            />

                                        </FormGroup>
                                    </FormControl>
                                </Grid>

                                {/* Right Side */}
                                {skills.AdminAccess && (
                                    <Grid item xs={12} md={4}>
                                        <FormControl margin="normal">
                                            <FormLabel>Quote Admin Configuration</FormLabel>

                                            <FormGroup>

                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={qcConfig.table1}
                                                            onChange={this.handleCheckboxChangeQc}
                                                            name="table1"
                                                        />
                                                    }
                                                    label="Backup Records"
                                                />

                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={qcConfig.table2}
                                                            onChange={this.handleCheckboxChangeQc}
                                                            name="table2"
                                                        />
                                                    }
                                                    label="Deletion Report"
                                                />

                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                )}

                            </Grid>

                        </DialogContent>
                        <DialogActions
                            sx={{
                                padding: '16px',
                                paddingTop: '12px',
                                justifyContent: 'flex-end',
                                backgroundColor: '#f9fafa'
                            }}
                        >
                            <Button
                                type='button'
                                variant="contained"
                                sx={{
                                    textTransform: 'none',
                                    padding: '3px 15px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    borderRadius: '8px',
                                    backgroundColor: '#1976d2',
                                    '&:hover': {
                                        backgroundColor: '#1565c0',
                                    }
                                }}
                                onClick={() => this.resetDialogState()}
                            >
                                Cancel
                            </Button>
                            <Button
                                type='submit'
                                variant="contained"
                                sx={{
                                    textTransform: 'none',
                                    padding: '3px 15px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    borderRadius: '8px',
                                    backgroundColor: '#1976d2',
                                    '&:hover': {
                                        backgroundColor: '#1565c0',
                                    }
                                }}
                            >
                                {this.state.selectedRowForEdit ? "Update" : "Create"}
                            </Button>
                        </DialogActions>
                    </Box>

                </Dialog>
                <GridTable sx={{ height: '90vh' }} displaysidebar={this.props.displaysidebar}>
                    <Grid container direction="column" spacing={0} sx={{ height: '100%', display: "contents", padding: '10px', }}>
                        <Grid item sx={{ height: '7vh' }}>
                            <Grid container spacing={0}>
                                <Grid item lg={11.5} sm={11}>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <Box display="flex" alignItems="center" gap={0}>
                                            <TextField
                                                size="small"
                                                placeholder="Search User"
                                                value={this.state.searchText}
                                                onChange={(e) =>
                                                    this.setState({ searchText: e.target.value })
                                                    // this.onSearch(e)
                                                }
                                                sx={{
                                                    '& .MuiInputBase-input::placeholder': {
                                                        fontSize: '11px',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '11px',
                                                    },
                                                    width: 200,
                                                }}
                                            />
                                            <Tooltip title="Click here for search result">
                                                <IconButton
                                                    sx={{ mr: 1.5, height: '33px', border: '0.2px solid #d0bcbca1', borderRadius: '9%' }}
                                                    onClick={() => this.onSearch({ target: { value: this.state.searchText } })}
                                                >
                                                    <Search fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>

                                        <Tooltip
                                            title="Click here to Add User"
                                        >
                                            <span>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    sx={{
                                                        fontSize: "10px",
                                                        backgroundColor: "#501e75",
                                                        "&.Mui-disabled": {
                                                            backgroundColor: "#d3d3d3",
                                                            color: "#8c8c8c",
                                                        },
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            isOpenEditDialog: true,
                                                            email: "",
                                                            skills: {
                                                                AdminAccess: false,
                                                            },
                                                            qcConfig: {
                                                                table1: false,
                                                                table2: false
                                                            },
                                                            qcDeletionConfig: {
                                                                table13: false,
                                                            },
                                                            // deletionConfig: {
                                                            //     table2: false,
                                                            //     table4: false,
                                                            //     table5: false,
                                                            // },
                                                            errors: {
                                                                email: "",
                                                            },
                                                            isQcGlobalAdmin: false,
                                                            selectedRowForEdit: null,
                                                        });
                                                    }}
                                                >
                                                    Add User
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </div>
                                </Grid>
                                <Grid item lg={.5} sm={1} marginTop={0.5}>
                                    <Tooltip title={"Click here to refresh the table"}>
                                        <span>
                                            <Refresh
                                                sx={{ cursor: "pointer", color: "blue", boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px', border: '0.1px solid black' }}
                                                onClick={() => {
                                                    this.setState({ searchText: "" });
                                                    this.UpdateUserAccessList();
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item sx={{ height: '75vh', overflow: 'scroll' }}>
                            <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #edebeb' }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold' }}>S.No</TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold' }}>UserName </TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold' }}>UserAccess </TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 60, fontWeight: 'bold' }}>Action </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody style={tableData?.length === 0 ? { height: '150px', alignItems: 'center', justifyContent: 'center' } : {}}>
                                        {tableData?.length === 0 ? (
                                            <TableRow>
                                                <TableCell
                                                    colSpan={3}
                                                    sx={{
                                                        textAlign: "center",
                                                        height: "150px",
                                                        fontSize: "12px",
                                                        padding: 0,
                                                    }}
                                                >
                                                    No records to display
                                                </TableCell>
                                            </TableRow>

                                        ) : (
                                            tableData?.map((row, index) => {
                                                return (
                                                    <TableRow hover key={row.key + index}>
                                                        <TableCell sx={{ fontSize: '11px', width: 60 }}>
                                                            {index + 1}
                                                        </TableCell>

                                                        <TableCell sx={{ fontSize: '11px', width: 110 }}>
                                                            {row.UserName}
                                                        </TableCell>

                                                        <TableCell>
                                                            {(() => {
                                                                return (
                                                                    row?.value &&
                                                                    row?.value?.split(",")?.map((item: any, index: any) => (
                                                                        <Chip
                                                                            key={index}
                                                                            label={item.trim()}
                                                                            size="small"
                                                                            sx={{
                                                                                ...this.getChipColor(item),
                                                                                mr: 0.5,
                                                                                mb: 0.5,
                                                                                borderRadius: "16px",
                                                                                fontWeight: 500,
                                                                                "& .MuiChip-label": {
                                                                                    px: 1.5,
                                                                                },
                                                                            }}
                                                                        />
                                                                    ))
                                                                );
                                                            })()}
                                                        </TableCell>

                                                        <TableCell sx={{ fontSize: '11px', width: 60 }}>
                                                            <div style={{ display: 'flex', gap: '10px' }}>
                                                                {
                                                                    row.IsActive ?
                                                                        <Cancel fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                            this.setState({
                                                                                confirmationDialog: {
                                                                                    isOpen: true,
                                                                                    recordId: row,
                                                                                    message: `Are you Sure you want to deactivate access for this User: ${row.UserName}?`,
                                                                                    activate: false
                                                                                }
                                                                            });
                                                                        }} style={{ color: red[500] }} />
                                                                        :
                                                                        <CheckIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                            this.setState({
                                                                                confirmationDialog: {
                                                                                    isOpen: true,
                                                                                    recordId: row,
                                                                                    message: `Are you Sure you want to activate access for this User: ${row.UserName}?`,
                                                                                    activate: true
                                                                                }
                                                                            });
                                                                        }} style={{ color: green[500] }} />
                                                                }
                                                                <Tooltip title={row.IsActive ? "Cannot edit active record" : "Click here to Edit"}>
                                                                    <Edit
                                                                        fontSize="small"
                                                                        sx={{
                                                                            cursor: !row.IsActive ? "not-allowed" : "pointer",
                                                                            color: !row.IsActive ? "text.disabled" : "inherit",
                                                                            opacity: !row.IsActive ? 0.5 : 1,
                                                                        }}
                                                                        onClick={() => {
                                                                            if (row.IsActive) {
                                                                                this.MapForEditingRow(row);
                                                                            }
                                                                        }}
                                                                    />
                                                                </Tooltip>
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        )}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </Grid>
                    </Grid>

                </GridTable >

                <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
                    this.setState({
                        confirmationDialog: {
                            isOpen: false,
                            recordId: 0,
                            message: "",
                            activate: false,
                        }
                    });
                }} />
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2500}
                    onClose={() => this.setState({ snackbarOpen: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={() => this.setState({ snackbarOpen: false })} severity={snackbarSeverity} sx={{ width: "100%" }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </div >
        );
    }
}
